import { render } from "./EditarEmpresaView.vue?vue&type=template&id=3111ed97&ts=true"
import script from "./EditarEmpresaView.vue?vue&type=script&lang=ts"
export * from "./EditarEmpresaView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__